var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHumanBubbleIcon = function SvgHumanBubbleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.556.889c-4.656 0-8.445 3.788-8.445 8.444 0 1.476.393 2.934 1.094 4.136.101.327-.17 1.498-.704 2.033a1.332 1.332 0 0 0 .87 2.274q.133.007.268.007c1.116 0 2.417-.35 3.374-.787a8.3 8.3 0 0 0 3.54.784c4.655 0 8.444-3.789 8.444-8.445S28.212.89 23.556.89M8.09 20.445a4.889 4.889 0 1 0 0-9.778 4.889 4.889 0 0 0 0 9.778m6.758 9.333H1.333a1.335 1.335 0 0 1-1.267-1.75 8.425 8.425 0 0 1 8.023-5.806 8.43 8.43 0 0 1 8.025 5.807 1.334 1.334 0 0 1-1.266 1.749",
    clipRule: "evenodd"
  })));
};
export default SvgHumanBubbleIcon;